<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Lista de autorizaciones</h2>
      </b-col>
    </b-row>

    <div class="mt-4">

      <b-tabs content-class="p-3" v-model="tabActual">

        <!-- Tab Tabla autorizaciones revisadas -->
        <b-tab title="Autorizaciones">
          <b-form ref="filtros" @submit.prevent="cargarRegistros">

            <b-form-row>
              <b-col md="4">
                <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde">
                  <b-input-group>
                    <b-input id="input-filtro-fecha-desde" placeholder="Desde" v-model="filtros.desde"></b-input>
                    <b-datepicker :initial-date="hoy" v-model="filtros.desde" button-only show-decade-nav></b-datepicker>
                    <b-input placeholder="Hasta" v-model="filtros.hasta"></b-input>
                    <b-datepicker :initial-date="hoy" v-model="filtros.hasta" show-decade-nav button-only></b-datepicker>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Día:" label-for="input-filtro-dia">
                  <b-form-select id="input-filtro-dia" v-model="filtros.dia">
                    <b-select-option :value="''"></b-select-option>
                    <b-select-option v-for="(dia,i) in dias" :key="i" :value="i + 1">{{ dia }}</b-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="4">
                <b-form-group label="Codigo:" label-for="input-filtro-codigo">
                  <b-form-input id="input-filtro-codigo" type="text" v-model="filtros.codigo"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Nombre:" label-for="input-filtro-nombre">
                  <b-form-input id="input-filtro-nombre" type="text" v-model="filtros.nombre"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="NRC:" label-for="input-filtro-nrc">
                  <div class="input-group">
                    <b-form-input id="input-filtro-periodo" placeholder="Periodo" type="text" v-model="filtros.periodo" :state="checkNrc"></b-form-input>
                    <b-form-input id="input-filtro-nrc" placeholder="NRC" type="text" v-model="filtros.nrc" :state="checkNrc"></b-form-input>
                  </div>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-button variant="primary" type="submit">Filtrar</b-button>
              </b-col>
            </b-form-row>
          </b-form>

          <b-table responsive striped hover :items="registros" :fields="camposAutorizaciones">
            <template #cell(fecha_inicio)="row">
              <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
            </template>
            <template #cell(fecha_fin)="row">
              <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
            </template>
          </b-table>
          <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
        </b-tab>

        <!-- Tab carga de documentos -->
        <b-tab title="Cargue Masivo" v-if="$auth.can('validar_autorizaciones')">
          <b-overlay :show="showOverlay" rounded="sm" variant="white">
            <b-row class="mt-4 d-flex align-items-center">

              <b-col sm="3">
                <label for="input-none">Cargue Masivo</label>
              </b-col>

              <b-col v-if="!archivoHorarios">
                <b-input-group>
                  <b-form-file v-model="file" type="file" :state="Boolean(file)" placeholder="Selecciona el archivo de autorizaciones..." drop-placeholder="Suelta el archivo..." accept=".xlsx"></b-form-file>
                  <b-button variant="warning" @click="submitFile">Procesar</b-button>
                </b-input-group>
              </b-col>

              <template v-else>
                <b-row>
                  <b-col>
                    <label for="input-none"><strong>Ya existe un archivo de autorizaciones</strong></label>
                  </b-col>

                  <b-col>
                    <b-row class="d-flex flex-row-reverse">
                      <b-button variant="success" class="ml-2 mr-4" @click="actualizarArchivo(true)">Adicionar</b-button>
                      <b-button variant="warning" class="ml-2 mr-4" @click="actualizarArchivo()">Reemplazar</b-button>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </b-row>
          </b-overlay>
          <b-row v-if="this.archivoHorarios" class="mt-4 d-flex align-items-center">

            <b-col sm="3">
              <label for="input-none">Estado de carga</label>
            </b-col>

            <b-col>
              <strong v-if="archivoCargando"><label for="input-none">Cargando Registros</label></strong>
              <strong v-else><label for="input-none">Registros Cargados</label></strong>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Tab Errores de carga -->
        <b-tab title="Errores de carga" v-if="$auth.can('validar_autorizaciones')">
          <b-table responsive striped hover :items="errores" :fields="camposErrores">
          </b-table>
          <b-pagination v-model="pageErrores" :total-rows="countErrores" :per-page="limitErrores" aria-controls="my-table" align="center"></b-pagination>
        </b-tab>

      </b-tabs>
    </div>

  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { url } from '../../../services/url_service'
import { DateTimeFormatter, LocalDate } from '@js-joda/core'

@Component
export default class AjustesControlAcceso extends Vue {
  public dias: Array<any> = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
  ]

  public page: number = 1
  public limit: number = 10
  public count: number = 0
  public registros: Array<any> = []
  public filtros: any = {
  }
  public orden: any = {
    columna: 'fecha_inicio',
    direccion: 'ASC',
  }

  public pageErrores: number = 1
  public limitErrores: number = 10
  public countErrores: number = 0
  public errores: Array<any> = []

  public file: File = null

  public archivoHorarios: boolean = false
  public archivoCargando: boolean = false
  public adicionarArchivo: boolean = false
  public archivoRegistros: string = ''

  public tabActual: number = 0

  // Iniciales
  public botonActivado: boolean = false
  public showOverlay: boolean = false

  public camposAutorizaciones: Array<any> = [
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'periodo',
      label: 'Periodo',
    },
    {
      key: 'nrc',
      label: 'Nrc',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
    {
      key: 'fecha_inicio',
      label: 'Fecha de inicio',
    },
    {
      key: 'fecha_fin',
      label: 'Fecha Final',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
  ]

  public camposErrores: Array<any> = [
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'registro',
      label: 'Registro',
    },
    {
      key: 'error',
      label: 'Error',
    },
    {
      key: 'created_at',
      label: 'Fecha del error',
    },
  ]

  public checkNrc: boolean = null

  get diaUno(): string {
    return LocalDate.of(LocalDate.now().year(), 1, 1).format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  get hoy(): string {
    return LocalDate.now().format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  public async cargarRegistros() {
    this.checkNrc = null
    if ((this.filtros.periodo && !this.filtros.nrc) || (this.filtros.nrc && !this.filtros.periodo)) {
      this.checkNrc = false
      return
    }

    let response = await axios.get(url.create('/internal/autorizaciones'), {
      params: {
        filtros: this.filtros,
        orden: this.orden,
        limit: this.limit,
        page: this.page,
      },
    })


    this.registros = response.data.data

    for (let registro of this.registros) {
      registro.dia = this.dias[registro.dia - 1]
    }
    this.count = response.data.count
  }

  public async cargarErrores() {
    let response = await axios.get(url.create('/internal/autorizaciones/errores'), {
      params: {
        limit: this.limitErrores,
        page: this.pageErrores,
      },
    })

    this.errores = response.data.data
    this.countErrores = response.data.count
  }

  public eliminarHoraFecha(fecha) {
    var fechaFinalSinHora = fecha.substring(0, fecha.indexOf(' '));
    return fechaFinalSinHora;
  }

  public async cargarDatos() {
    try {
      // Hacerlo por post multiparametro - ToDo
      let response;
      let data;

      response = await axios.get(
        url.create('/internal/parametros/existeArchivoHorario')
      )
      data = response.data
      this.archivoHorarios = data['valor'] === 'true'

      response = await axios.get(
        url.create('/internal/parametros/hayArchivoHorarioCargando')
      )
      data = response.data
      this.archivoCargando = data['valor'] === 'true'
    } catch (error) {
      this.$bvToast.toast('No se pudieron cargar los datos', {
        title: 'Fallo en el servidor',
        variant: 'danger',
      })
    }
  }

  public async submitFile() {

    if (this.file && this.archivoHorarios == false) {
      this.showOverlay = true
      this.archivoCargando = true

      this.$bvToast.toast('El archivo será subido en segundo plano', {
        title: 'Cargando datos',
        variant: 'info',
      })

      try {
        let formData = new FormData()
        formData.append('UPLOAD', this.file)
        let response = await axios.post(
          url.create('/internal/autorizaciones'),
          formData,
          {
            params: {
              agregar: this.adicionarArchivo,
            },
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        this.cargarDatos()
        this.cargarRegistros()
        this.cargarErrores()

        this.showOverlay = false
        this.archivoCargando = false
        this.archivoHorarios = true

        this.$bvToast.toast(
          'Los horarios han sido cargados exitosamente ' + response.data,
          {
            title: 'Archivo actualizado correctamente',
            variant: 'success',
            autoHideDelay: 5000,
          }
        )
      } catch (ex) {
        this.$bvToast.toast('No se pudieron registrar los datos', {
          title: 'Archivo no actualizado',
          variant: 'danger',
        })

        this.showOverlay = false
        this.archivoCargando = false
        this.archivoHorarios = true
        this.adicionarArchivo = false
      }
    }
  }


  public actualizarArchivo(adicionar = false) {
    this.archivoHorarios = false
    this.adicionarArchivo = adicionar
  }

  @Watch('page')
  public pageChange(val) {
    this.cargarRegistros()
    this.cargarErrores()
  }

  created() {
    this.cargarDatos()
    this.cargarRegistros()
    this.cargarErrores()
  }
}
</script>

<style>
.tab-content {
  background-color: #ffffff;
}
</style>